export default __webpack_public_path__ + "static/media/CompleteCalendarFail.6c280436.svg";